module.exports = __webpack_public_path__ + "static/partner-microsoft-5e099f97d31b4d6d7d9a25cac0e11ad8.jpg";